
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
import CommonReportChart from '@/components/common/CommonReportChart.vue';
import { getOldInterface } from '@/apis/index';
import { STAT, URLVER } from '@/config/config';
import {
  formatName,
  formatRead,
  formatDate,
  jumpReport,
  formatRating,
  changeRatingStyle,
  jumpTimeShare,
  pushBy2804,
  formatTime,
  takePat,
  formatChg,
  formatManyChg,
} from '@/utils/tools';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
@Component({
  components: {
    CommonBlockLine,
    CommonReportChart,
    CommonRankNumber,
  },
})
export default class ReportCard extends Vue {
  temp = 0;
  inPage = '';
  isSub = 0;
  @Prop() private item!: object;
  @Prop() private chart!: boolean;
  @Prop() private index!: number;
  @Prop() private needSub!: boolean;
  @Prop() private needFollow!: boolean;
  @Prop() private swiperIndex!: number;
  @Prop() private reportList!: Array<object>;
  @Prop() private priceData!: any;
  @Prop() private deepReport!: boolean;
  formatName = formatName;
  formatRead = formatRead;
  formatDate = formatDate;
  formatRating = formatRating;
  formatChg = formatChg;
  formatManyChg = formatManyChg;
  @Watch('$route', { deep: true, immediate: true })
  // eslint-disable-next-line consistent-return
  onRouteChange(newVal: any) {
    if (newVal.name === 'home') {
      this.inPage = STAT.follow;
    } else if (newVal.name === 'mainPage') {
      if (window.getParam('swCode') !== '') {
        this.inPage = STAT.industry;
      }
      if (window.getParam('authorId') !== '') {
        this.inPage = STAT.author;
      }
      if (window.getParam('orgId') !== '') {
        this.inPage = STAT.org;
      }
    } else if (newVal.name === 'stockPage') {
      this.inPage = STAT.stock;
    } else if (newVal.name === 'iframe') {
      this.inPage = STAT.kline;
    } else {
      return false;
    }
  }
  //研报跳转
  jumpReport(item: any) {
    item.pid && jumpReport(item.pid);
  }
  jumpTitleReport(item: any) {
    this.sendReportStat('title');
    item.pid && jumpReport(item.pid);
  }
  get isFollow() {
    const { authorId, orgId } = this.item as any;
    if (orgId) {
      return this.$followOrgList[orgId];
    } else {
      return authorId ? this.$followAuthorList[authorId] : this.$followOrgList[orgId];
    }
  }
  followInstead(item: any, status: any) {
    //关注机构
    getOldInterface({
      act: 'follow',
      con: 'user',
      type: 2,
      status,
      followId: item,
    })
      .then(res => {
        if (res.statusCode === 0) {
          this.followSet(item, status);
          this.$emit('orgInMain');
          this.$emit('getIsFollow', this.reportList, item, 1);
        }
        if (res.statusCode === 300) {
          this.$toast('用户未登录');
        }
      })
      .catch(() => {
        this.$toast('接口开小差了');
      });
  }
  followSet(item: any, status: number) {
    this.isSub = 0;
    if (status > 0) {
      this.isSub = 2;
    } else {
      this.isSub = 1;
    }
    if (!item.orgId) {
      this.$set(this.$followAuthorList, item.authorId, this.isSub);
    } else {
      this.$set(this.$followOrgList, item.orgId, this.isSub);
    }
  }
  followAuthor(item: any, status: any) {
    if (!window.getAccount()) {
      window.location.href = 'http://eqhexin/changeUser';
    } else {
      this.followInstead(item, status);
    }
  }
  changeDate(time: any) {
    const now = new Date();
    const publish = new Date(time.replace(new RegExp(/-/gm), '/'));
    const obj = {
      '-86400000': '昨日',
      '0': '今日',
    };
    return obj[publish.setHours(0, 0, 0, 0) - now.setHours(0, 0, 0, 0)] || formatTime(publish, 'yyyy-MM-dd');
  }
  formatTime(time: any) {
    return this.changeDate(time);
  }
  //格式化cat数据
  formatCat(cat: any) {
    if (cat) {
      if (cat.indexOf('!') === -1) {
        return cat;
      } else {
        return cat.slice(0, cat.indexOf('!'));
      }
    } else {
      return false;
    }
  }
  //跳转分时
  jumpToFenshi(item: any) {
    this.sendReportStat('ggfs');
    const params = {
      market: item.market,
      stockCode: item.stockCode || item.code,
    };
    jumpTimeShare(params);
  }
  //多个股票跳转分时
  jumpFenshi(item: any, j: number) {
    this.sendReportStat('ggfs');
    const params = {
      market: null,
      stockCode: item.stockCode.split('!')[j],
    };
    jumpTimeShare(params);
  }
  //拍一拍
  takePat(index: number) {
    takePat(this, index);
  }
  // eslint-disable-next-line consistent-return
  clickDate(index: number) {
    if (window.location.href.indexOf('mainPage') !== -1 && window.getParam('swCode') === '') {
      this.takePat(index);
    } else {
      return false;
    }
  }
  sendReportStat(action: any) {
    if (this.$route.name === 'mainPage') {
      if (window.getParam('swCode') !== '') {
        window.hxmPageStat(`${STAT.industry}.${action}`, URLVER);
      }
      if (window.getParam('orgId') !== '') {
        window.hxmPageStat(`${STAT.org}.${action}`, URLVER);
      }
      if (window.getParam('authorId') !== '') {
        window.hxmPageStat(`${STAT.author}.${action}`, URLVER);
      }
    } else if (this.$route.name === 'stockPage') {
      window.hxmPageStat(`${STAT.stock}.${action}`, URLVER);
    } else {
      window.hxmPageStat(`${STAT.follow}.${action}`, URLVER);
    }
  }
  //主页点击头像拍一拍
  clickAvatar(index: number, item: any) {
    this.sendReportStat('jgzy');
    if (this.$route.name === 'mainPage' && window.getParam('swCode') === '') {
      this.takePat(index);
    } else {
      this.newJump(item);
    }
  }
  newJump(item: any) {
    if (item.orgId) {
      const param = {
        orgId: item.orgId,
        name: item.orgName,
      };
      pushBy2804('/mainPage', param);
    }
  }
  jumpAuthor(item: any) {
    this.sendReportStat('fxszy');
    if (item.authorId) {
      const param = {
        authorId: item.authorId,
        name: item.author,
        org: item.orgName,
      };
      pushBy2804('/mainPage', param);
    }
  }
  jumpOrg(index: any, item: any) {
    this.sendReportStat('jgzy');
    if (window.location.href.indexOf('mainPage') !== -1 && window.getParam('swCode') === '') {
      this.takePat(index);
    } else {
      this.newJump(item);
    }
  }
  get stockInfo() {
    const { pid, stockName, stockCode, orgName, orgId, author, authorId, market } = this.item as any;
    return {
      stockName,
      stockCode,
      orgName,
      orgId,
      author,
      authorId,
      market,
      pid,
    };
  }
  changeStyle(item: any) {
    return changeRatingStyle(this.deepReport, item);
  }
}
